<label
  class="ui-textarea-field"
  [class.ui-textarea-field-invalid]="isInvalid()"
>
  @if (hasLabel()) {
    <span class="ui-textarea-label">{{ label() }}</span>
  }
  <textarea
    class="ui-textarea-control"
    [id]="textareaId()"
    [attr.name]="name()"
    [attr.placeholder]="placeholder()"
    [attr.rows]="rows()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-describedby]="describedBy()"
    [attr.aria-invalid]="isInvalid() ? 'true' : null"
    [attr.maxlength]="maxLength()"
    [value]="value()"
    [disabled]="disabled()"
    [readOnly]="readonly()"
    [required]="required()"
    (input)="handleInput($event)"
    (blur)="handleBlur()"
  ></textarea>
</label>
@if (hasError()) {
  <p class="ui-textarea-message ui-textarea-message-error" [id]="errorId()">
    {{ errorText() }}
  </p>
} @else if (hasHelper()) {
  <p class="ui-textarea-message" [id]="helperId()">{{ helperText() }}</p>
}
